import React from "react";

import { Stack } from "../layouts/stack/Stack";
import { Badge, BadgeProps } from "./Badge";

interface BadgeListProps {
    items: BadgeProps[];
    rowLength?: number;
}

const defaultRowLength = 6;

export const BadgeList: React.FC<BadgeListProps> = ({ items, rowLength }: BadgeListProps) => {
    return <Stack tokens={{ childrenGap: 5 }}>{renderRows(items, rowLength ?? defaultRowLength)}</Stack>;
};

const renderRows = (items: BadgeProps[], rowLength: number) => {
    const rowsCount = Math.ceil(items.length / rowLength);

    const rows: React.ReactNode[] = [];

    for (let index = 0; index < rowsCount; index++) {
        const rowItems = items.slice(index * rowLength, (index + 1) * rowLength);

        rows.push(renderRow(rowItems));
    }

    return rows;
};

const renderRow = (items: BadgeProps[]): React.ReactNode => {
    return (
        <Stack horizontal={true} tokens={{ childrenGap: 5 }}>
            {items.map((item) => {
                return <Badge key={item.text} text={item.text} color={item.color} size={item.size} />;
            })}
        </Stack>
    );
};
